import { toTitleCase } from "../../../Utils/stringUtls";
import {
  credit_dataMigAttr,
  credit_programType,
  dataMigerationTypewithValue,
} from "../../CreditInstance/ProgramInformation/FieldsListingLabels";
import {
  commercialPrepaid,
  consumerPrepaid,
  dataMigAttr,
  dataMigInfo,
  generalEntityType,
  programTypeDebit,
  programTypePrepaid,
} from "../ProgramInformation/FieldsListingLabels";
import { timeZones } from "../ProgramInformation/ProgramInformation";
import ReviewAttribute from "../../../Components/SharedComponent/ReviewAttribute/ReviewAttribute";
import ReviewSummarySectionHeading from "../../../Components/SharedComponent/ReviewSummarySectionHeading/ReviewSummarySectionHeading";

const ProgramInformationOverview = ({ data, type = "debit" }) => {
  const programTypeDebitLabels = programTypeDebit.map((el) => el.label);
  if (!data) return null;
  let data1 = data["0_0"];

  data1 = data["1_0"];

  // Add safety check for data1
  if (!data1) {
    console.error(
      "data1 is undefined. Available keys in data:",
      Object.keys(data),
    );
    return null;
  }

  const {
    pi_program_name,
    pi_standard_time,
    pi_program_debit_or_credit,
    pi_card_program,
    pi_program_type_prepaid,
    //only credit field
    pi_program_type,
    pi_type_of_migration,
    pi_type_of_processor_name,

    pi_system_records_debit,
    pi_system_records_debit_other,
    pi_auth_transac_debit,
    pi_auth_transac_debit_other,
    pi_program_type_debit,
    pi_program_type_debit_other,
    pi_program_type_prepaid_other,
    pi_selected_commercial_types,
    pi_selected_consumer_types,
    pi_commercial_type_other,
    pi_consumer_type_other,
    pi_proposition_value,
    pi_segment_value,
    pi_card_program_currency,
    pi_setup_type,
    pi_ecount_1,
    pi_ecount_2,
    pi_ecount_3,
    pi_ecount_4,
    pi_evalue_1,
    pi_evalue_2,
    pi_evalue_3,
    pi_evalue_4,
    pi_evolume_1,
    pi_evolume_2,
    pi_evolume_3,
    pi_evolume_4,
    pi_current_processor_name,
    pi_key_component_custodians,
    pi_key_component_custodians_other,
    pi_data_migration_attributes,
    pi_data_migration_attributes_other,
    pi_cpm_compliant,
    pi_migration_type,
    pi_mig_np_ecount_1,
    pi_mig_np_ecount_2,
    pi_mig_np_ecount_3,
    pi_mig_np_ecount_4,
    pi_mig_np_evalue_1,
    pi_mig_np_evalue_2,
    pi_mig_np_evalue_3,
    pi_mig_np_evalue_4,
    pi_mig_np_evolume_1,
    pi_mig_np_evolume_2,
    pi_mig_np_evolume_3,
    pi_mig_np_evolume_4,
    pi_mig_mp_ecount_1,
    pi_mig_mp_ecount_2,
    pi_mig_mp_ecount_3,
    pi_mig_mp_ecount_4,
    pi_mig_mp_evalue_1,
    pi_mig_mp_evalue_2,
    pi_mig_mp_evalue_3,
    pi_mig_mp_evalue_4,
    pi_mig_mp_evolume_1,
    pi_mig_mp_evolume_2,
    pi_mig_mp_evolume_3,
    pi_mig_mp_evolume_4,
  } = data1;
  const migrationTypeObj = dataMigerationTypewithValue.find(
    (item) => item.value === pi_migration_type,
  );


  return (
    <div className="forms-instance" style={{ color: "#111" }}>
        <ReviewSummarySectionHeading title="Program Scope" className='font-bold mt-0'/>
      <div i2c-grid="grid" className="review-summary-gap">
        <div i2c-grid="12@md">
          <div className="mt-16 review-summary-section-heading mb-8">
            Program Name
          </div>
        </div>
        <div i2c-grid="6@md">
          <ReviewAttribute
            label="Program Name"
            value={pi_program_name?.length ? pi_program_name : "-"}
          />
        </div>
        {type === "debit" && (
          <div i2c-grid="6@md">
            <ReviewAttribute
              label="Instance Time Zone for Reporting"
              value={
                pi_standard_time?.length
                  ? timeZones.find((zon) => zon.value === pi_standard_time)
                      ?.label
                  : "-"
              }
            />
          </div>
        )}
        {type === "debit" ? (
          <div i2c-grid="12@md">
            <ReviewAttribute
              label="Will the program be Debit or Prepaid"
              value={
                pi_program_debit_or_credit?.length
                  ? toTitleCase(pi_program_debit_or_credit)
                  : "-"
              }
            />
          </div>
        ) : null}
        {pi_program_debit_or_credit === "debit" && (
          <>
            <div i2c-grid="12@md">
              <ReviewAttribute
                label="Who would be the system of records?"
                value={
                  pi_system_records_debit?.map((entity, index) => {
                    return (
                      <span key={index}>
                        {generalEntityType[entity].label === "Other"
                          ? pi_system_records_debit_other + ", "
                          : generalEntityType[entity].label + ", "}
                      </span>
                    );
                  }) || "-"
                }
              />
            </div>

            <div i2c-grid="12@md">
              <ReviewAttribute
                label="Who would be authorizing the transactions?"
                value={
                  pi_auth_transac_debit?.map((entity, index) => {
                    return (
                      <span key={index}>
                        {generalEntityType[entity].label === "Other"
                          ? pi_auth_transac_debit_other + ", "
                          : generalEntityType[entity].label + ", "}
                      </span>
                    );
                  }) || "-"
                }
              />
            </div>
          </>
        )}
        {pi_program_debit_or_credit === "prepaid" && (
          <div i2c-grid="12@md">
            <ReviewAttribute
              label="Reloadable or Non-Reloadable Card Program"
              value={
                pi_card_program?.length ? toTitleCase(pi_card_program) : "-"
              }
            />
          </div>
        )}
        <div i2c-grid="12@md">
          <div className="review-summary-section-heading mb-8">
            Program Type
          </div>
          <ReviewAttribute
            label="Program Type"
            value={
              type === "debit"
                ? pi_program_debit_or_credit === "prepaid"
                  ? pi_program_type_prepaid === 2
                    ? pi_program_type_prepaid_other 
                      ? `Other (${pi_program_type_prepaid_other})`
                      : "Other"
                    : programTypePrepaid[pi_program_type_prepaid]?.label
                  : pi_program_type_debit
                      ?.map((a) =>
                        programTypeDebitLabels[a] === "Other"
                          ? pi_program_type_debit_other
                          : programTypeDebitLabels[a],
                      )
                      ?.map((val, index) => (
                        <span key={index}>{val + ", "}</span>
                      ))
                : Array.isArray(pi_program_type)
                  ? pi_program_type
                      .map(
                        (val) =>
                          credit_programType.find((type) => type.value === val)
                            ?.label,
                      )
                      .filter(Boolean)
                      .join(", ")
                  : (credit_programType.find(
                      (type) => type.value === pi_program_type,
                    )?.label ?? "")
            }
          />
        </div>

        {type === "debit" &&
        pi_program_type_prepaid === 0 &&
        pi_program_debit_or_credit !== "debit" ? (
          <div i2c-grid="12@md">
            <ReviewAttribute
              label="Consumer Type Channels"
              value={pi_selected_consumer_types
                ?.map((a) =>
                  a === 7 ? pi_consumer_type_other : consumerPrepaid[a].label,
                )
                ?.map((val, index) => (
                  <li key={index}>{val}</li>
                ))}
            />
          </div>
        ) : (
          type === "debit" &&
          pi_program_debit_or_credit !== "debit" &&
          pi_program_type_prepaid === 1 && (
            <div i2c-grid="12@md">
              <ReviewAttribute
                label="Commercial Type Channels"
                value={pi_selected_commercial_types
                  ?.map((a) =>
                    a === 4
                      ? pi_commercial_type_other
                      : commercialPrepaid[a].label,
                  )
                  ?.map((val, index) => (
                    <li key={index}>{val + ", "}</li>
                  ))}
              />
            </div>
          )
        )}

        <div i2c-grid="12@md">
          <div className="review-summary-section-heading mb-8">
            Program Description
          </div>
          <div className="overview-val-text review-summary-gap" i2c-grid="grid 6@md">
            <div>
              <ReviewAttribute
                label="What is the value proposition, how is the program different form other options in the market?"
                value={
                  pi_proposition_value?.length ? pi_proposition_value : "-"
                }
              />
            </div>
            <div>
              <ReviewAttribute
                label="Which segment of the market is this program going to be targeted towards?"
                value={pi_segment_value?.length ? pi_segment_value : "-"}
              />
            </div>
          </div>
        </div>

        {type === "debit" ? (
          <div i2c-grid="12@md">
            <ReviewAttribute
              label="Card Program Currency"
              value={
                pi_card_program_currency?.length
                  ? pi_card_program_currency
                  : "-"
              }
            />
          </div>
        ) : null}

        <div i2c-grid="12@md">
          <div className="review-summary-section-heading mb-8">
            Setup Type
          </div>
          <ReviewAttribute
            label="Setup Type"
            value={pi_setup_type?.length ? toTitleCase(pi_setup_type) : "-"}
          />
        </div>

        {pi_setup_type !== "migration" && type !== "credit" && (
          <div i2c-grid="12@md">
            <div className="review-summary-section-heading mb-8">
              Projection at Launch
            </div>
            <div className="overview-val-text review-summary-gap" i2c-grid="grid 6@md">
              <div>
                <ReviewAttribute
                  label="Estimated Count (Number of cards to be migrated)"
                  value={
                    [pi_ecount_1, pi_ecount_2, pi_ecount_3, pi_ecount_4].some(
                      (v) => v,
                    )
                      ? (pi_ecount_1 || "-") +
                        " ," +
                        (pi_ecount_2 || "-") +
                        " ," +
                        (pi_ecount_3 || "-") +
                        " ," +
                        (pi_ecount_4 || "-")
                      : "-"
                  }
                />
              </div>
              <div>
                <ReviewAttribute
                  label="Estimated Value (Estimated transaction value)"
                  value={
                    [pi_evalue_1, pi_evalue_2, pi_evalue_3, pi_evalue_4].some(
                      (v) => v,
                    )
                      ? (pi_evalue_1 || "-") +
                        " ," +
                        (pi_evalue_2 || "-") +
                        " ," +
                        (pi_evalue_3 || "-") +
                        " ," +
                        (pi_evalue_4 || "-")
                      : "-"
                  }
                />
              </div>

              <div>
                <ReviewAttribute
                  label="Estimated Volume (Estimated transaction volume)"
                  value={
                    [
                      pi_evolume_1,
                      pi_evolume_2,
                      pi_evolume_3,
                      pi_evolume_4,
                    ].some((v) => v)
                      ? (pi_evolume_1 || "-") +
                        " ," +
                        (pi_evolume_2 || "-") +
                        " ," +
                        (pi_evolume_3 || "-") +
                        "," +
                        (pi_evolume_4 || "-")
                      : "-"
                  }
                />
              </div>
            </div>
          </div>
        )}

        {((pi_setup_type === "migration" && type !== "credit") ||
          type === "credit") && (
          <div i2c-grid="12@md">
            {pi_setup_type === "migration" && (
              <>
                <div className="overview-val-text review-summary-gap" i2c-grid="grid 6@md">
                  <div>
                    <ReviewAttribute
                      label="Type of Migration"
                      value={
                        pi_type_of_migration?.length
                          ? toTitleCase(pi_type_of_migration.replace("-", " "))
                          : "-"
                      }
                    />
                  </div>
                </div>
                {type === "debit" ? (
                  <div className="overview-val-text mt-16">
                    <ReviewAttribute
                      label="Please specify the bank or processor name"
                      value={
                        pi_type_of_processor_name?.length
                          ? pi_type_of_processor_name
                          : "-"
                      }
                    />
                  </div>
                ) : (
                  <div className="overview-val-text mt-16" i2c-grid="">
                    <div>
                      <ReviewAttribute
                        label="Bank or Current Processor Name"
                        value={
                          pi_type_of_processor_name?.length
                            ? pi_type_of_processor_name
                            : "-"
                        }
                      />
                    </div>
                  </div>
                )}
              </>
            )}
              <>
                <div className="review-summary-section-heading mb-8 mt-8">
                  Data Migration Information
                </div>
                <div className="overview-val-text mt-4" i2c-grid="">
                  <ReviewAttribute
                    label="Current Processor Name"
                    value={
                      pi_current_processor_name?.length
                        ? pi_current_processor_name
                        : "-"
                    }
                  />
                </div>
              </>

            <div className="mt-16">
              <ReviewAttribute
                label="Existing Clear Key Components Custodian"
                value={pi_key_component_custodians?.map((custodian, index) => {
                  return (
                    <span key={index}>
                      {dataMigInfo[custodian].label === "Other"
                        ? pi_key_component_custodians_other + ", "
                        : dataMigInfo[custodian].label + ", "}
                    </span>
                  );
                }) || "-"}
              />
            </div>
          </div>
        )}
        {type === "credit" && (
          <div i2c-grid="12@md">
            <ReviewAttribute
              label="Migration Attributes"
              value={
                credit_dataMigAttr
                  .filter((attr) =>
                    pi_data_migration_attributes?.includes(attr.value),
                  )
                  .map((attr) =>
                    attr.value === 16
                      ? pi_data_migration_attributes_other?.length
                        ? pi_data_migration_attributes_other
                        : "-"
                      : attr.label,
                  )
                  .join(", ") || "-"
              }
            />
          </div>
        )}
        {type === "debit" && pi_setup_type === "migration" ? (
          <div i2c-grid="12@md">
            <ReviewAttribute
              label="Migration Attributes"
              value={
                dataMigAttr
                  .filter((attr) =>
                    pi_data_migration_attributes?.includes(attr.value),
                  )
                  .map((attr) =>
                    attr.value === 4
                      ? pi_data_migration_attributes_other?.length
                        ? pi_data_migration_attributes_other
                        : "-"
                      : attr.label,
                  )
                  .join(", ") || "-"
              }
            />
          </div>
        ) : (
          ""
        )}

        {((type === "debit" && pi_setup_type === "migration") ||
          type === "credit") && (
          <div i2c-grid="12@md">
            <ReviewAttribute
              label="Data Migration"
              value={
                migrationTypeObj
                  ? migrationTypeObj.label
                  : "-"
              }
            />
          </div>
        )}
        {pi_setup_type !== "migration" &&
          (pi_migration_type === "new-program" ||
            pi_migration_type === "both") &&
          type === "credit" && (
            <div i2c-grid="12@md">
              <div className="review-summary-section-heading">
                New Program Projections
              </div>
              <div className="overview-val-text" i2c-grid="grid 6@md">
                <div>
                  <ReviewAttribute
                    label="Estimated Count (Number of cards to be migrated)"
                    value={
                      pi_mig_np_ecount_1 +
                      "," +
                      pi_mig_np_ecount_2 +
                      "," +
                      pi_mig_np_ecount_3 +
                      "," +
                      pi_mig_np_ecount_4
                    }
                  />
                </div>
                <div>
                  <ReviewAttribute
                    label="Estimated Value (Estimated transaction value)"
                    value={
                      pi_mig_np_evalue_1 +
                      "," +
                      pi_mig_np_evalue_2 +
                      "," +
                      pi_mig_np_evalue_3 +
                      "," +
                      pi_mig_np_evalue_4
                    }
                  />
                </div>

                <div>
                  <ReviewAttribute
                    label="Estimated Volume (Estimated transaction volume)"
                    value={
                      pi_mig_np_evolume_1 +
                      "," +
                      pi_mig_np_evolume_2 +
                      "," +
                      pi_mig_np_evolume_3 +
                      "," +
                      pi_mig_np_evolume_4
                    }
                  />
                </div>
              </div>
            </div>
          )}

        {pi_setup_type === "new-program" &&
          pi_migration_type !== "new-program" &&
          type === "credit" && (
            <div i2c-grid="12@md">
              <div className="review-summary-section-heading mb-8">
                Migration Program Projections
              </div>
              <div className="overview-val-text review-summary-gap" i2c-grid="grid gap-sm 6@md">
                <div>
                  <ReviewAttribute
                    label="Estimated Count (Number of cards to be migrated)*"
                    value={
                      [
                        pi_mig_mp_ecount_1,
                        pi_mig_mp_ecount_2,
                        pi_mig_mp_ecount_3,
                        pi_mig_mp_ecount_4,
                      ].some((v) => v)
                        ? (pi_mig_mp_ecount_1 || "-") +
                          "," +
                          (pi_mig_mp_ecount_2 || "-") +
                          "," +
                          (pi_mig_mp_ecount_3 || "-") +
                          "," +
                          (pi_mig_mp_ecount_4 || "-")
                        : "-"
                    }
                  />
                </div>
                <div>
                  <ReviewAttribute
                    label="Estimated Value (Transaction value of the migrated cards)*"
                    value={
                      [
                        pi_mig_mp_evalue_1,
                        pi_mig_mp_evalue_2,
                        pi_mig_mp_evalue_3,
                        pi_mig_mp_evalue_4,
                      ].some((v) => v)
                        ? (pi_mig_mp_evalue_1 || "-") +
                          "," +
                          (pi_mig_mp_evalue_2 || "-") +
                          "," +
                          (pi_mig_mp_evalue_3 || "-") +
                          "," +
                          (pi_mig_mp_evalue_4 || "-")
                        : "-"
                    }
                  />
                </div>

                <div>
                  <ReviewAttribute
                    label="Estimated Volume (Transaction volume of the migrated cards)*"
                    value={
                      [
                        pi_mig_mp_evolume_1,
                        pi_mig_mp_evolume_2,
                        pi_mig_mp_evolume_3,
                        pi_mig_mp_evolume_4,
                      ].some((v) => v)
                        ? (pi_mig_mp_evolume_1 || "-") +
                          "," +
                          (pi_mig_mp_evolume_2 || "-") +
                          "," +
                          (pi_mig_mp_evolume_3 || "-") +
                          "," +
                          (pi_mig_mp_evolume_4 || "-")
                        : "-"
                    }
                  />
                </div>
              </div>
            </div>
          )}

        {
          pi_setup_type === "migration" &&
            (pi_migration_type === "new-program" ||
              pi_migration_type === "both") && (
              <div i2c-grid="12@md">
                <div className="review-summary-section-heading">
                  New Program Projections
                </div>
                <div className="overview-val-text" i2c-grid="grid 6@md">
                  <div>
                    <ReviewAttribute
                      label="Estimated Count (Number of cards in sevice)"
                      value={`${pi_mig_np_ecount_1?.length ? pi_mig_np_ecount_1 : "-"},${pi_mig_np_ecount_2?.length ? pi_mig_np_ecount_2 : "-"},${pi_mig_np_ecount_3?.length ? pi_mig_np_ecount_3 : "-"},${pi_mig_np_ecount_4?.length ? pi_mig_np_ecount_4 : "-"}`}
                    />
                  </div>
                  <div>
                    <ReviewAttribute
                      label="Estimated Value (Transaction value)"
                      value={`${pi_mig_np_evalue_1?.length ? pi_mig_np_evalue_1 : "-"},${pi_mig_np_evalue_2?.length ? pi_mig_np_evalue_2 : "-"},${pi_mig_np_evalue_3?.length ? pi_mig_np_evalue_3 : "-"},${pi_mig_np_evalue_4?.length ? pi_mig_np_evalue_4 : "-"}`}
                    />
                  </div>

                  <div>
                    <ReviewAttribute
                      label="Estimated Volume (Transaction volume)"
                      value={`${pi_mig_np_evolume_1?.length ? pi_mig_np_evolume_1 : "-"},${pi_mig_np_evolume_2?.length ? pi_mig_np_evolume_2 : "-"},${pi_mig_np_evolume_3?.length ? pi_mig_np_evolume_3 : "-"},${pi_mig_np_evolume_4?.length ? pi_mig_np_evolume_4 : "-"}`}
                    />
                  </div>
                </div>
              </div>
            )
          // ) : (
          //   <div i2c-grid="12@md">
          //     <div className="overview-help-text font-bold">
          //       Migration Program Projections
          //     </div>
          //     <div className="overview-val-text" i2c-grid="grid 6@md">
          //       <div>
          //         <div className="overview-help-text font-bold">
          //           Estimated Count (Number of cards to be migrated)
          //         </div>
          //         <div className="overview-val-text">
          //           {pi_ecount_1?.length ? pi_ecount_1 : "-"},
          //           {pi_ecount_2?.length ? pi_ecount_2 : "-"},
          //           {pi_ecount_3?.length ? pi_ecount_3 : "-"},
          //           {pi_ecount_4?.length ? pi_ecount_4 : "-"}
          //         </div>
          //       </div>
          //       <div>
          //         <div className="overview-help-text font-bold">
          //           Estimated Value (Transaction value of the migrated cards)
          //         </div>
          //         <div className="overview-val-text">
          //           {pi_evalue_1?.length ? pi_evalue_1 : "-"},
          //           {pi_evalue_2?.length ? pi_evalue_2 : "-"},
          //           {pi_evalue_3?.length ? pi_evalue_3 : "-"},
          //           {pi_evalue_4?.length ? pi_evalue_4 : "-"}
          //         </div>
          //       </div>

          //       <div>
          //         <div className="overview-help-text font-bold">
          //           Estimated Value (Transaction volume of the migrated cards)
          //         </div>
          //         <div className="overview-val-text">
          //           {pi_evolume_1?.length ? pi_evolume_1 : "-"},
          //           {pi_evolume_2?.length ? pi_evolume_2 : "-"},
          //           {pi_evolume_3?.length ? pi_evolume_3 : "-"},
          //           {pi_evolume_4?.length ? pi_evolume_4 : "-"}
          //         </div>
          //       </div>
          //     </div>
          //   </div>
          // ))
        }
        {pi_setup_type === "migration" &&
          (pi_migration_type === "migration-program" ||
            pi_migration_type === "both") &&
          (type === "credit" ? (
            <div i2c-grid="12@md">
              <div className="review-summary-section-heading mb-8">
                Migration Program Projections{" "}
              </div>
              <div className="overview-val-text review-summary-gap" i2c-grid="grid 6@md">
                <div>
                  <ReviewAttribute
                    label="Count (Number of cards to be migrated)"
                    value={
                      [pi_mig_mp_ecount_1, pi_mig_mp_ecount_2, pi_mig_mp_ecount_3, pi_mig_mp_ecount_4].some((v) => v?.length)
                        ? (pi_mig_mp_ecount_1 || "-") + "," + (pi_mig_mp_ecount_2 || "-") + "," + (pi_mig_mp_ecount_3 || "-") + "," + (pi_mig_mp_ecount_4 || "-")
                        : "-"
                    }
                  />
                </div>
                <div>
                  <ReviewAttribute
                    label="Value (Estimated transaction value)"
                    value={
                      [pi_mig_mp_evalue_1, pi_mig_mp_evalue_2, pi_mig_mp_evalue_3, pi_mig_mp_evalue_4].some((v) => v?.length)
                        ? (pi_mig_mp_evalue_1 || "-") + "," + (pi_mig_mp_evalue_2 || "-") + "," + (pi_mig_mp_evalue_3 || "-") + "," + (pi_mig_mp_evalue_4 || "-")
                        : "-"
                    }
                  />
                </div>

                <div>
                  <ReviewAttribute
                    label="Volume (Estimated transaction volume)"
                    value={
                      [pi_mig_mp_evolume_1, pi_mig_mp_evolume_2, pi_mig_mp_evolume_3, pi_mig_mp_evolume_4].some((v) => v?.length)
                        ? (pi_mig_mp_evolume_1 || "-") + "," + (pi_mig_mp_evolume_2 || "-") + "," + (pi_mig_mp_evolume_3 || "-") + "," + (pi_mig_mp_evolume_4 || "-")
                        : "-"
                    }
                  />
                </div>
              </div>
            </div>
          ) : (
            <div i2c-grid="12@md">
              
              <div className="overview-val-text" i2c-grid="grid 6@md">
                <div>
                  <ReviewAttribute
                    label="Count (Number of cards to be migrated)"
                    value={
                      [pi_ecount_1, pi_ecount_2, pi_ecount_3, pi_ecount_4].some((v) => v?.length)
                        ? (pi_ecount_1 || "-") + "," + (pi_ecount_2 || "-") + "," + (pi_ecount_3 || "-") + "," + (pi_ecount_4 || "-")
                        : "-"
                    }
                  />
                </div>
                <div>
                  <ReviewAttribute
                    label="Value (Estimated transaction value)"
                    value={
                      [pi_evalue_1, pi_evalue_2, pi_evalue_3, pi_evalue_4].some((v) => v?.length)
                        ? (pi_evalue_1 || "-") + "," + (pi_evalue_2 || "-") + "," + (pi_evalue_3 || "-") + "," + (pi_evalue_4 || "-")
                        : "-"
                    }
                  />
                </div>

                <div>
                  <ReviewAttribute
                    label="Volume (Estimated transaction volume)"
                    value={
                      [pi_evolume_1, pi_evolume_2, pi_evolume_3, pi_evolume_4].some((v) => v?.length)
                        ? (pi_evolume_1 || "-") + "," + (pi_evolume_2 || "-") + "," + (pi_evolume_3 || "-") + "," + (pi_evolume_4 || "-")
                        : "-"
                    }
                  />
                </div>
              </div>
            </div>
          ))}
        {type === "debit" && (
          <div i2c-grid="12@md">
            <div className="review-summary-section-heading mb-8">
                Card Program Manager - PCI Compliant{" "}
              </div>
            <ReviewAttribute
              label="Card Program Manager - PCI Compliant"
              value={pi_cpm_compliant?.length ? pi_cpm_compliant : "-"}
            />
          </div>
        )}
      </div>
      <div className="divider-bottom mt-16"></div>
    </div>
  );
};
export default ProgramInformationOverview;
